import { createApp } from 'vue';
import mitt from 'mitt';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import './assets/css/main.css';
import './assets/css/vue-select.css';
import { library, config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { faSearch, faPlus, faMinus, faChevronRight, faChevronDown, faToggleOff, faToggleOn, faCheck, faCheckCircle, faTimesCircle, faAngleDoubleRight, faPlusCircle, faMinusCircle, faQuestionCircle, faUserTimes } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare as farCheckSquare, faSquare as farSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { createBootstrap, vBToggle, vBModal, vBTooltip } from 'bootstrap-vue-next';
import * as BootstrapVueNext from 'bootstrap-vue-next';

import sanitizeHtml from 'sanitize-html';
import BModalCompat from './compat/BModalCompat.vue';
import { bvModalCompat } from './compat/bModalCompat';

const config = {
    allowedTags: [],
    allowedAttributes: {}
};

function applySanitize(el) {
    const clean = sanitizeHtml(el.value, config);
    if (el.value !== clean) {
        el.value = clean;
        el.dispatchEvent(new Event('input', { bubbles: true }));
    }
}

const sanitizeHtmlDirective = {
    mounted(el) {
        applySanitize(el);
        el.addEventListener('change', () => applySanitize(el));
        el.addEventListener('blur', () => applySanitize(el));
        el.addEventListener('paste', () => {
            setTimeout(() => applySanitize(el), 0);
        });
    },
    updated(el) {
        applySanitize(el);
    }
};

fontAwesomeConfig.autoAddCss = false;
library.add(faSearch, faPlus, faMinus, faChevronRight, faChevronDown, faToggleOff, faToggleOn, faCheck, faCheckCircle, faTimesCircle, faAngleDoubleRight, farCheckSquare, farSquare, faPlusCircle, faMinusCircle, faQuestionCircle, faUserTimes);

export const eventbus = mitt();

const app = createApp(App);

app.use(router);
app.use(store);
app.use(createBootstrap());

Object.keys(BootstrapVueNext).forEach((name) => {
    if (/^B[A-Z]/.test(name)) {
        const component = BootstrapVueNext[name];
        if (component && (typeof component === 'object' || typeof component === 'function')) {
            app.component(name, component);
        }
    }
});

app.directive('b-toggle', vBToggle);
app.directive('b-modal', vBModal);
app.directive('b-tooltip', vBTooltip);

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('v-select', vSelect);
app.component('b-modal', BModalCompat);
app.component('BModal', BModalCompat);

app.directive('sanitize-html', sanitizeHtmlDirective);

app.config.globalProperties.$http = axios;
app.config.globalProperties.$bvModal = bvModalCompat;

app.mount('#app');
